// Filas por página en todas las tablas (acordado con la clienta el 06-10-2026).
export const PAGE_SIZE = 6;
